namespace TabAurous.ProductDevelopment {
    export namespace CustomerRequirementBOMService {
        export const baseUrl = 'ProductDevelopment/CustomerRequirementBOM';

        export declare function Create(request: Serenity.SaveRequest<CustomerRequirementBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CustomerRequirementBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerRequirementBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/CustomerRequirementBOM/Create",
            Update = "ProductDevelopment/CustomerRequirementBOM/Update",
            Delete = "ProductDevelopment/CustomerRequirementBOM/Delete",
            Retrieve = "ProductDevelopment/CustomerRequirementBOM/Retrieve",
            List = "ProductDevelopment/CustomerRequirementBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CustomerRequirementBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
